import * as React from 'react';
import { FC, ReactNode, useState } from 'react';

const Expander: FC<{ children: ReactNode; text: string; className: string }> = ({ children, text, className }) => {
  const [opened, setOpened] = useState(false);

  return (
    <div className={`expander ${className}`}>
      <div className="rs-text-align_right">
        <button type="button" className="btn" aria-expanded={opened} onClick={() => setOpened((v) => !v)}>
          {text}
          <i className={`expander-arrow ${opened ? 'rs-icon-caret-down' : 'rs-icon-caret-right'}`} />
        </button>
      </div>
      <div className="area" style={{ display: opened ? 'block' : 'none' }}>
        {children}
      </div>
    </div>
  );
};

export default Expander;
